"use strict";
/**
 * @module Services.RemoteServers
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var serialiser_1 = require("./../../serialisers/serialiser");
var check_remote_server_result_1 = require("./../../services/remote-servers/check-remote-server-result");
var read_remote_server_status_1 = require("./read-remote-server-status");
/**
 * Serialiser for {@link CheckRemoteServerResult}
 */
var CheckRemoteServerResultSerialiserClass = /** @class */ (function (_super) {
    __extends(CheckRemoteServerResultSerialiserClass, _super);
    function CheckRemoteServerResultSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link ListRemoteServersResult} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link ListRemoteServersResult} that was read
     */
    CheckRemoteServerResultSerialiserClass.prototype.read = function (bis) {
        var status = read_remote_server_status_1.readRemoteServerStatus(bis);
        return new check_remote_server_result_1.CheckRemoteServerResult(status);
    };
    return CheckRemoteServerResultSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.CheckRemoteServerResultSerialiserClass = CheckRemoteServerResultSerialiserClass;
/**
 * The {@link CheckRemoteServerResultSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.CheckRemoteServerResultSerialiser = new CheckRemoteServerResultSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/remote-servers/check-remote-server-result-serialiser.js
// module id = 1985
// module chunks = 1